import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import nlTranslations from './locales/nl.json';

i18n.use(initReactI18next).init({
  fallbackLng: 'nl',
  lng: 'nl',
  debug: true,
  resources: {
    nl: {
      translation: nlTranslations,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
